<script lang="ts" setup>
import { PropType, onMounted, ref } from 'vue';
import { Notification } from '@/core/collections/notification/notification.interface';
import { useStore } from '@/core/hooks/useStore';

const { commit } = useStore();

const props = defineProps({
   notification: { type: Object as PropType<Notification>, default: () => ({}) },
   history: { type: Boolean, default: false },
});

const timer = ref();
onMounted(() => {
   if (timer.value) clearTimeout(timer.value);
   if (!props.notification.timeout) return;
   timer.value = setTimeout(() => {
      handleRemoveNotification();
   }, props.notification?.timeout || 5000);
});

function handleRemoveNotification() {
   if (timer.value) clearTimeout(timer.value);

   commit('notification/REMOVE_NOTIFICATION', props.notification);
}
</script>
<template>
   <div class="notification">
      <div :class="['notification__color', `-${notification.type}`]"></div>
      <div class="notification__content">
         <p class="notification__content-title" v-html="notification.title"></p>
         <p v-if="notification?.action && notification?.actionText" class="button--link" @click="notification.action">
            {{ notification.actionText }}
         </p>
      </div>
      <i v-if="!history" class="icon fas fa-times" @click="handleRemoveNotification"></i>
   </div>
</template>
<style lang="scss" scoped>
.notification {
   display: grid;
   grid-template-columns: 1.6rem auto 4rem;
   align-items: center;
   gap: var(--spacing);
   background-color: var(--dark);

   border-radius: var(--border-radius);
   filter: drop-shadow(var(--drop-shadow));
   overflow: hidden;
   width: fit-content;
   min-width: 20rem;

   font-size: var(--font-size-small);
   font-weight: normal;
}

.notification__color {
   height: 100%;

   &.-success {
      background-color: var(--success);
   }

   &.-warning {
      background-color: var(--warning);
   }

   &.-danger {
      background-color: var(--error);
   }

   &.-info {
      background-color: var(--grey);
   }
}
</style>
